
import { getUserFromLocalStorage } from '../utils/localStorage-utils';
import { axiosAdminSimple } from './useAxios';


function failedReturn(message) {
  return {
    isOk: false,
    message
  }
}
function successReturn(data, message) {
  return {
    isOk: true,
    data,
    message
  }
}

export async function signIn(email, password) {
  try {
    const data = {
      email: email,
      password: password,
      tenantId: null,
      rememberMe: false
    }
    //console.log("signIn",`${process.env.BASE_URL}:${process.env.REACT_APP_PORT_ADMIN}`)
    return await axiosAdminSimple.post("/api/Authentication/Login", data)
      .then((response) => {
        if (response.status == 200)
          return successReturn(response.data.data)
        else
          return failedReturn("Authentication failed")
      })
      .catch((error) => {
      
        return failedReturn(error.response ? error.response.data.error.message : error.message);

      })
  }
  catch {
    return failedReturn("Authentication failed")
  }
}

export async function checkUserToken(user) {
  try {

    if (!user)
      return undefined
    
    let tokenExpireDate = new Date(user.tokenExpireDate)
    let refreshTokenExpireDate = new Date(user.refreshTokenExpireDate)
    let now = new Date()

    if (refreshTokenExpireDate < now)
      return undefined

    if (tokenExpireDate < now) {
      await axiosAdminSimple.post('/api/Authentication/RefreshToken',
        { refreshToken: user.refreshToken },
      )
        .then((response) => {
          user = response.data.data
        })
        .catch(function (error) {
          return undefined
        });
    }

    return user

  } catch (error) {
    return undefined
  }
}

export async function getUser() {
  try {
    let tmpUser = getUserFromLocalStorage()

    if (!tmpUser)
      return failedReturn()

    tmpUser = await checkUserToken(tmpUser).then((user) => user)

    if (tmpUser)
      return successReturn(tmpUser)
    else
      return failedReturn()
  }
  catch {
    return failedReturn()
  }
}

export async function createAccount(email, password) {
  try {
    // Send request
    //console.log(email, password);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to create account"
    };
  }
}

export async function changePassword(email, recoveryCode) {
  try {
    // Send request
    //console.log(email, recoveryCode);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  }
}

export async function resetPassword(email) {
  try {
    // Send request
    //console.log(email);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to reset password"
    };
  }
}
